import { createReducer, on } from "@ngrx/store";
import { UserInfo } from "src/app/models/authentication/user-info";
import { AuthenticationActions, SettingsActions } from "../actions";

export interface AuthenticationState {
  user?: UserInfo;
  isLoggingIn: boolean;
  hasLoginError: boolean;
  isResettingPassword: boolean;
}

const initialState = {
  isLoggingIn: false,
  hasLoginError: false,
  isResettingPassword: false,
} as AuthenticationState;

export const authenticationReducer = createReducer(
  initialState,
  on(AuthenticationActions.login, () => ({
    ...initialState,
    isLoggingIn: true,
    hasLoginError: false,
  })),
  on(AuthenticationActions.loginFailed, () => ({
    ...initialState,
    hasLoginError: true,
  })),
  on(AuthenticationActions.loggedIn, (state, action) => ({
    ...state,
    isLoggingIn: false,
    user: action.userInfo,
  })),
  on(AuthenticationActions.logout, () => initialState),
  on(AuthenticationActions.forgotPassword, (state, _) => ({
    ...state,
    isResettingPassword: true,
  })),
  on(AuthenticationActions.forgotPasswordLinkSendingFailed, (state, _) => ({
    ...state,
    isResettingPassword: false,
  })),
  on(AuthenticationActions.forgotPasswordLinkSent, (state, _) => ({
    ...state,
    isResettingPassword: false,
  })),
  on(SettingsActions.changedLanguage, (state, action) => ({
    ...state,
    user:
      state.user != undefined
        ? { ...state.user, language: action.language }
        : undefined,
  })),
);
